import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Button, Heading, Text, Truncated } from '@frontend/design-system';
import { useScheduleAppointmentInfoPanelShallowStore } from '../../../stores/schedule-appointment-info-panel.store';
import { AppointmentEventActionButtons } from '../../schedule-calendar-components/appointment-event-card/appointment-event-action-buttons';

const MOCK_APPOINTMENT_INFO = {
  personId: 'b0f1085e-d06c-5aa5-9cda-a25e7e85e51d',
  locationId: 'f7029eeb-e14b-4337-b093-401d6c88662b',
  appointmentId: 'dd5abf22-9990-4e0e-a076-a5a2875bb285',
  personName: 'Paggy Long Name Wigglebottom',
  personGender: 'Non-Binary',
  personStatus: 'Active',
  personAge: '43 Yrs',
};

export const PanelHeader = () => {
  const { selectedAppointments, resetSelectedAppointment } = useScheduleAppointmentInfoPanelShallowStore(
    'selectedAppointments',
    'resetSelectedAppointment'
  );
  const isOverlappingPanelOpen = selectedAppointments.length > 1;
  const [personFirstWord, personRestWord] = (MOCK_APPOINTMENT_INFO.personName ?? '').split(/\s(.*)/s);

  return (
    <header css={headerStyle}>
      <div css={{ width: '100%', display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
        {isOverlappingPanelOpen && (
          <Button variant='secondary' iconName='caret-left' onClick={resetSelectedAppointment} />
        )}
        <Truncated as={Heading} level={2} css={{ fontWeight: 'normal' }}>
          <strong>{personFirstWord}</strong> {personRestWord}
        </Truncated>
        <Icon name='shield-small' color='subdued' css={{ minWidth: 'min-content' }} />
      </div>
      <div css={{ display: 'flex', gap: theme.spacing(2), justifyContent: 'center' }}>
        <Truncated as={Text} size='small' color='subdued' css={{ maxWidth: 50 }}>
          {MOCK_APPOINTMENT_INFO.personId}
        </Truncated>
        <Text size='small' color='subdued'>
          {MOCK_APPOINTMENT_INFO.personStatus}
        </Text>
        <Text size='small' color='subdued'>
          {MOCK_APPOINTMENT_INFO.personGender}
        </Text>
        <Text size='small' color='subdued'>
          {MOCK_APPOINTMENT_INFO.personAge}
        </Text>
      </div>
      <AppointmentEventActionButtons
        locationId={MOCK_APPOINTMENT_INFO.locationId}
        personId={MOCK_APPOINTMENT_INFO.personId}
        appointmentId={MOCK_APPOINTMENT_INFO.appointmentId}
      />
    </header>
  );
};

const headerStyle = css({
  borderBottom: `1px solid ${theme.colors.neutral10}`,
  padding: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: theme.spacing(1),
});
